import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Media from 'react-media';
import GlobalTheme, { breakpointValues } from '../../../styled/GlobalTheme';
import mediaQueries from '../../../utils/mediaQueries';

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  ${GlobalTheme.breakpoints.down('sm')}{
    flex-direction: column;
  }
  @media (max-height: 425px) {
    padding: 10px;
  }
`;

const ImageBox = styled.div`
  height: 140px;
  width: 330px;
  ${({ hasPiper }) => hasPiper && `
    height: 91px;
    width: 157px;
    margin-right: 32px;
  `}
  @media ${mediaQueries.mdUp} {
    height: 276px;
    width: 650px;
    ${({ hasPiper }) => hasPiper && `
      height: 179px;
      width: 309px;
      margin-right: 32px;
    `}
  }
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const BodySlider = ({ images, hasPiper }) => (
  <Media queries={{
    sm: `(max-width: ${breakpointValues.md - 1}px)`,
    md: `(min-width: ${breakpointValues.md}px)`,
  }}
  >
    {(matches) => {
      let image;
      if (matches.md) image = images.md;
      if (matches.sm) image = images.sm;
      return (
        <Container>
          <ImageBox hasPiper={hasPiper}>
            <Image
              src={image}
            />
          </ImageBox>
        </Container>
      );
    }}
  </Media>
);

BodySlider.propTypes = {
  images: PropTypes.shape({
    lg: PropTypes.string,
    md: PropTypes.string,
    sm: PropTypes.string,
  }).isRequired,
  hasPiper: PropTypes.bool.isRequired,
};

export default BodySlider;
